import { ASSET_PATHS } from "./assets";

export const FeatureShowcase = () => (
  <section className="relative py-16 md:py-24 bg-gradient-to-b from-[#23164c] via-[#32294d] to-[#000000] overflow-hidden">
    <div className="container mx-auto px-4 text-center">
      <h2 className="font-pixel text-white text-2xl sm:text-3xl md:text-4xl mb-2 md:mb-4">
        Craft seamless, secure, and lightning-fast experiences
      </h2>
      <p className="font-pixel text-white text-xl sm:text-2xl md:text-3xl mb-12 md:mb-20">
        with CaptchaSonic intuitive, bot-proof interface!
      </p>
    </div>
    
    <div className="container mx-auto px-4 relative">
      {/* Feature Cards Layout - Now BEHIND the whiteboard */}
      <div className="relative z-0 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
        {/* Left Column */}
        <div className="space-y-8 md:space-y-16 flex flex-col items-center md:items-start">
          <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg transform hover:scale-105 transition-transform duration-300">
            <img src={ASSET_PATHS.featureCards.card1} className="object-contain w-full" alt="Feature Card 1" />
            <img src={ASSET_PATHS.featureCards.star} className="absolute -top-4 -left-4 md:top-auto md:left-12 w-12 h-12 md:w-16 md:h-16 animate-pulse" alt="Star" />
          </div>
          <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg transform hover:scale-105 transition-transform duration-300">
            <img src={ASSET_PATHS.featureCards.card3} className="object-contain w-full" alt="Feature Card 3" />
          </div>
        </div>
        {/* Right Column */}
        <div className="space-y-8 md:space-y-16 flex flex-col items-center md:items-end">
          <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg transform hover:scale-105 transition-transform duration-300">
            <img src={ASSET_PATHS.featureCards.card2} className="object-contain w-full" alt="Feature Card 2" />
            <img src={ASSET_PATHS.featureCards.star} className="absolute -bottom-4 -right-4 md:top-32 md:right-12 w-12 h-12 md:w-16 md:h-16 animate-pulse" alt="Star" />
          </div>
          <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg transform hover:scale-105 transition-transform duration-300">
            <img src={ASSET_PATHS.featureCards.card4} className="object-contain w-full" alt="Feature Card 4" />
          </div>
        </div>
      </div>

      {/* Whiteboard Image - Now IN FRONT (higher z-index) */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl z-10 pointer-events-none">
        <img
          className="w-full h-auto opacity-90 "
          src={ASSET_PATHS.featureCards.whiteBoard}
          alt="Whiteboard foreground"
        />
      </div>
    </div>
  </section>
);